<template>
	<!-- 问题列表 -->
	<div class="iccue-box">
		<div class="b-wsc-b">常见问题</div>
		<!-- 问题盒子 -->
		<div class="iccue-list">
			<van-collapse v-model="activeNames">
				<block v-for="(item,index) in list" :key="index">
					<van-collapse-item :title="item.knownledgeTitle" :name="item.id">
						<!-- -->
						<div v-html="`'<style>img{width: 100% !important;}</style>' ${item.content}`" class="issue-val"></div>
					</van-collapse-item>
				</block>
			</van-collapse>
		</div>
		<div style="height: 132px"></div>
		<div class="intell-box">
			<a href="tel://02887652006">
				<van-cell is-link title="拨打客服电话" />
			</a>
			<van-cell is-link title="投诉及建议留言" @click="navSuggest" />
			<van-button @click="navIntelligentChat" type="primary" block>智能在线客服</van-button>
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeNames: [],
				show:false,
				list:[],
				source:''
			}
		},
		created() {
			this.source = (this.getParams('source') || '1').replace(/\//g,'');
			console.log('source',this.source);
			this.getData(this.source);
		},
		methods:{
			// 打开提议
			navSuggest(){
				this.$router.push('/suggest')
			},
			// 打开客服
			navIntelligentChat(){
				this.$router.push('/intelligent-chat')
			},
			// 提交
			getData(source){
				let params = {
					"comment": source
				}
				console.log(1,params);
				this.$httpRequest.request(
					'yxm/com/yxm/v1/answer/selectOftenAnswer',
					params,
					true,
					'POST',
					(response)=>{
						console.log(response);
						if(response.data.success){
							// response.data.data.content += 
							console.log('123',response.data.data.content);
							this.list = response.data.data;
						}else{
							this.$toast(response.data.msg);
						}
					}
				);
			},
			/**
			 * 获取页面路径参数值
			 */
			getParams(key) {
				var result = {};
				var paramStr = encodeURI(window.document.location.search);
				if (paramStr) {
					paramStr = paramStr.substring(1);
					var params = paramStr.split('&');
					for (var p = 0; p < params.length; p++) {
						result[params[p].split('=')[0]] = unescape(params[p].split('=')[1]);
					}
				}
				return result[key];
			},
		}
	}
</script>

<style lang="less" scoped>
	.iccue-box{
		img{
			width: 100%;
			height: 100%;
		}
		&>div:nth-child(1){
			padding: 10px 10px;
			
		}
		.iccue-list{
			// height: 300px;
		}
	}
	.intell-box{
		box-sizing: border-box;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100%;
		
	}
	.issue-val{
		img { -ms-interpolation-mode: bicubic; }
		
		img { width: 100%; }
	}
</style>



// WEBPACK FOOTER //
// src/page/soule/intelligent-chat/issue-list.vue